import { variantSearchResultSchema } from "@redotech/redo-conversion-core-common/split-slices";
import * as z from "zod";

export const searchProductVariants = {
  name: "searchProductVariants" as const,
  input: z.object({ query: z.string(), teamId: z.string() }),
  output: z.array(variantSearchResultSchema),
};
